export default function Tabs(theme) {
    return {
        MuiTab: {
            styleOverrides: {
                root: {
                    fontSize: '16px !important',
                    fontWeight: "500 !important",
                    fontFamily: 'Lato',
                    '&.Mui-selected': {
                        color: theme.palette.primary.darker,
                    },
                    '&:not(.Mui-selected)': {
                        color: theme.palette.primary.darker
                    }
                },
            }
        }
    };
}